import { Clock, CheckCircle, Play, XCircle, Trash2 } from 'lucide-react';

// Operational Status configs
export const OPERATIONAL_STATUSES = {
  new: { labelKey: 'status.new', color: 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300', icon: Clock },
  confirmed: { labelKey: 'status.confirmed', color: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400', icon: CheckCircle },
  in_progress: { labelKey: 'status.in_progress', color: 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400', icon: Play },
  done: { labelKey: 'status.done', color: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400', icon: CheckCircle },
  cancelled: { labelKey: 'status.cancelled', color: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400', icon: XCircle },
  deleted: { labelKey: 'status.deleted', color: 'bg-gray-100 text-gray-500 dark:bg-gray-800 dark:text-gray-400', icon: Trash2 },
};

// Payment Status configs
export const PAYMENT_STATUSES = {
  unpaid: { labelKey: 'status.unpaid', color: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400' },
  partial: { labelKey: 'status.partial', color: 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400' },
  paid: { labelKey: 'status.paid', color: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400' },
  refund: { labelKey: 'status.refund', color: 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400' },
};

// Priority configs
export const PRIORITIES = {
  low: { labelKey: 'priority.low', color: 'text-slate-500' },
  normal: { labelKey: 'priority.normal', color: 'text-blue-500' },
  high: { labelKey: 'priority.high', color: 'text-amber-500' },
  urgent: { labelKey: 'priority.urgent', color: 'text-red-500' },
};
